import React from "react";
import { format } from 'date-fns';

const Mate = (props) => {
    const {userinfo} = props;
    return (
        <tr>
            <td>{userinfo.name}</td>
            <td>{userinfo.email}</td>
            <td>{format(userinfo.created_at, 'MMM d, yyyy')}</td>
        </tr>
    );

}

export default Mate;